import { render, staticRenderFns } from "./ChangeOfMembership.vue?vue&type=template&id=963b663a&scoped=true&"
import script from "./ChangeOfMembership.vue?vue&type=script&lang=js&"
export * from "./ChangeOfMembership.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfMembership.vue?vue&type=style&index=0&id=963b663a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b663a",
  null
  
)

export default component.exports